export default "__VITE_ASSET__sgBSoiEX__"